import React, { useEffect } from "react";
import "../index.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import './OuraHome.css';
import './OuraNav.css';
import HeroShowcase from "./HeroShowcase";
import PartnerStrip from "./PartnerStrip";



const OuraHome = () => {
    useEffect(() => {
        AOS.init();
    }, []);

    return (
        <>
        <nav className="apple-global-nav public-nav">
            <div className="left-nav">
                <a href="#">
                    <img src="/images/logoPlaceholder1.png" alt="Logo" className="apple-logo"/>
                </a>
            </div>
            <div className="center-nav">
                <Link to="/demo">How It Works</Link>
                <a href="#models">Employee</a>
                <Link to="/admin/login">Admin Login</Link>
                <Link to="/apply">Apply</Link>
            </div>
        </nav>


            <div id="fullpage">
                {/* Administrator Section */}
                <div className="model3-container hero-lock">
                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="hero-video"
                    >
                        <source src="/videos/admin-hero.mp4" type="video/mp4"/>
                        Your browser does not support the video tag.
                    </video>

                    <div className="header-container">
                        <h1 className="header" data-aos="fade-up" data-aos-duration="1000">
                            Administrator
                        </h1>
                        <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
                            Dynamic, automated home health management — reliable solutions built for modern care teams.{" "}
                        </p>
                        <div
                            className="buttons"
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-duration="1000"
                        >
                            <Link to="/admin/login" className="btn1">
                                LOGIN
                            </Link>
                            <Link to="/admin/register" className="btn2">
                                REGISTER ORGANIZATION
                            </Link>
                        </div>
                        <div className="bottomArrow">
                            <a href="#models">
                                <i className="fa-solid fa-chevron-down down-arrow"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <PartnerStrip />

            <HeroShowcase id="how-it-works" />

            {/* Employee Section */}
            <div
                style={{backgroundImage: "url('images/background1.jpg')"}}
                className="model3-container"
            >
                <div id="models"></div>
                <div className="header-container">
                    <h1 className="header" data-aos="fade-up" data-aos-duration="1000">
                        Employee
                    </h1>
                    <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
                        Start Your Shift – Fast, Secure, Accurate
                        {/*} <a href="">Request</a> */}
                    </p>
                    <div
                        className="buttons"
                        data-aos="fade-up"
                        data-aos-delay="200"
                        data-aos-duration="1000"
                    >
                        <Link to="/employee/login" className="btn1">
                            Clock in
                        </Link>

                        <Link to="/apply" className="btn2">
                            Apply
                        </Link>
                    </div>
                        <div className="bottomArrow">
                            <a href="#modelx">
                                <i className="fa-solid fa-chevron-down down-arrow"></i>
                            </a>
                        </div>
                    </div>
                </div>
        </>
    );
};

export default OuraHome;
